'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _keeper = require('../keeper');

var _keeper2 = _interopRequireDefault(_keeper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var H5 = function () {
    function H5() {
        _classCallCheck(this, H5);

        this.type = 'html';
        this.keeper = undefined;
    }

    _createClass(H5, [{
        key: 'process',
        value: function process(succ, fail, next) {
            var _this = this;

            var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            // 预处理
            typeof succ == 'function' || (succ = this.noop);
            typeof fail == 'function' || (fail = this.noop);
            typeof next == 'function' || (next = this.noop);

            if (!this.supportGeo()) return next();
            opt.trigger = function (token) {
                fail({
                    code: 408,
                    message: _this.type + ' API Timeout:' + opt.timeout,
                    type: _this.type
                }, token);
            };
            this.keeper = new _keeper2.default(opt);

            try {
                navigator.geolocation.getCurrentPosition(function (crd) {
                    succ({
                        lat: crd.coords.latitude,
                        lng: crd.coords.longitude,
                        type: _this.type
                    }, _this.keeper.getToken());
                }, function () {
                    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                    fail({
                        code: e.code == 1 && /https/.test(location.protocol) && 401, // http协议问题走错误日志查看
                        message: (e.code || 'UNKOWN') + ': ' + (e.message || 'h5 get location error'),
                        type: _this.type
                    }, _this.keeper.getToken());
                }, {
                    enableHighAccuracy: true,
                    maximumAge: 30000, // 组件设置的默认缓存时间：30s
                    timeout: _config2.default.get('timeout') || 10000
                });
            } catch (e) {
                fail({
                    code: 400,
                    message: e && e.message || JSON.stringify(e),
                    type: this.type
                }, this.keeper.getToken());
            }
        }
    }, {
        key: 'supportGeo',
        value: function supportGeo() {
            return !!navigator.geolocation;
        }
    }]);

    return H5;
}();

var instance = new H5();
module.exports = instance.process.bind(instance);
module.exports.type = instance.type;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/whereami/lib/geos/html.js
// module id = 401
// module chunks = 0